import React from 'react';
import { Row, Col, Button, Alert } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

const LeagueConflictError = ({ errorData }) => {
    const history = useHistory();

    const handleGoBack = () => {
        history.push('/onboarding/username');
    };

    const handleContactSupport = () => {
        const subject = encodeURIComponent('League Conflict - Need Help');
        const body = encodeURIComponent(`Hi Support Team,

I'm experiencing a league conflict during onboarding. Here are the details:

Error: ${errorData?.error || 'Unknown error'}
Message: ${errorData?.message || 'No message provided'}

Please help me resolve this issue.

Thank you.`);

        window.location.href = `mailto:support@recapvid.com?subject=${subject}&body=${body}`;
    };

    return (
        <div className="pt-5 onboarding-section">    
            <Row className="onboarding-header">
                <Col xs={1} md={2}></Col>
                <Col xs={10} md={8}>       
                        
                    <Row className="text-center onboarding-title-row">
                        <Col className="onboarding-title">League Already Claimed</Col>
                    </Row>
                    
                    {/* Progress Bar - Show as stuck */}
                    <Row className="mt-4">
                        <Col>
                            <div className="text-center mb-2">
                                <span className="onboarding-progress-percentage">
                                    40% Complete
                                </span>
                            </div>
                            <div className="onboarding-progress">
                                <div 
                                    className="onboarding-progress-bar"
                                    style={{ width: '40%' }}
                                ></div>
                            </div>
                        </Col>
                    </Row>

                    <Row className="pt-4">
                        <Col>
                            <Alert variant="danger" className="mb-4">
                                <Alert.Heading>🚨 League Conflict Detected</Alert.Heading>
                                <p>
                                    The league you're trying to select is already associated with another user account.
                                </p>
                                <hr />
                                <p className="mb-0">
                                    <strong>What happened?</strong><br />
                                    This usually occurs when:
                                </p>
                                <ul className="mt-2">
                                    <li>Someone else has already claimed this league</li>
                                    <li>You may have multiple accounts</li>
                                    <li>There was a previous registration that wasn't completed</li>
                                </ul>
                            </Alert>

                            <div className="text-center mb-4">
                                <h5 className="text-white mb-3">How to resolve this:</h5>
                                
                                <div className="d-grid gap-3 d-md-block">
                                    <Button 
                                        variant="outline-light" 
                                        size="lg"
                                        onClick={handleGoBack}
                                        className="me-md-2 mb-2"
                                    >
                                        ← Try Different Username
                                    </Button>
                                    
                                    <Button 
                                        variant="primary" 
                                        size="lg"
                                        onClick={handleContactSupport}
                                        className="mb-2"
                                    >
                                        📧 Contact Support
                                    </Button>
                                </div>
                            </div>

                            <div className="text-center">
                                <p className="text-white-50">
                                    <strong>Support Email:</strong> <a 
                                        href="mailto:support@recapvid.com" 
                                        className="text-info"
                                        style={{ textDecoration: 'none' }}
                                    >
                                        support@recapvid.com
                                    </a>
                                </p>
                                <p className="text-white-50 small">
                                    Include your Sleeper username and the league name in your email for faster assistance.
                                </p>
                            </div>
                        </Col>
                    </Row>                        
                </Col>                            
            </Row>
        </div>
    );
};

export default LeagueConflictError;
